import { connect } from 'react-redux';

import DesktopPlayer from './desktop-player';


@connect(state => ({
  currentSiteUser: state.currentSiteUser,
}))
export default class FullScreenModalPlayer extends React.Component {

  static propTypes = {
    ..._.omit(DesktopPlayer.propTypes, [
      'playAtFullScreen',
      'showInitialOverlay',
      'showControls',
      'showPoster',
      'paused',
      'muted',
      'currentTime',
      'onFullScreenChanged',
    ]),
    currentSiteUser: React.PropTypes.object,
  };

  render() {
    const props = _.omit(this.props,
      'mobileMode', // can't do this
      'playAtFullScreen', // can't do this
      'showInitialOverlay', // can't do this
      'showControls', // can't do this
      'showPoster', // can't do this
      'currentTime', // can't do this
      'paused', // can't do this
      'muted', // can't do this
    );

    // For now there is no sense in DesktopPlayer but probably will be needed when implementing video background
    return (
      <DesktopPlayer {...props}
                     playAtFullScreen={false}
                     showInitialOverlay
                     showControls
                     showPoster
                     paused />
    );
  }

}



// WEBPACK FOOTER //
// ./src/widget/components/players/fs-modal-player.js